import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsDefectStatus, PmsDefectStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsDefectStatus>
    useData={usePmsDefectStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
